import React from 'react';
import { Page } from '../../../../../shared/Components/Page';
import {ValidacionesContainer} from './Screen';

export const ValidacionesView = () =>{

    return (
        <Page title={'Validaciones'}>{<ValidacionesContainer/>}</Page>
    )
}